export type AcatsDtccTransferType =
  | "FUL"
  | "FRV"
  | "MFC"
  | "PTD"
  | "PTR"
  | "RCL"
  | "RCR"
  | "PTF";

export const AcatsDtccTransferTypeDescriptions: Record<
  AcatsDtccTransferType,
  string
> = {
  FUL: "Standard Transfer (FUL)",
  FRV: "Fail Reversal (FRV)",
  MFC: "Mutual Fund Cleanup (MFC)",
  PTD: "Partial Transfer Deliverer (PTD)",
  PTR: "Partial Transfer Receiver (PTR)",
  RCL: "Reclaim (RCL)",
  RCR: "Residual Credit (RCR)",
  PTF: "Position Transfer Fund (PTF)",
};

export type AcatsDtccTransferStatus =
  | "REQUEST"
  | "REQUEST_ADJUST"
  | "REQUEST_ADJUST_PAST"
  | "REQUEST_PAST"
  | "REQUEST_REJECT"
  | "REVIEW"
  | "REVIEW_ADJUST_DELIVERER"
  | "REVIEW_ERROR"
  | "REVIEW_ACCELERATE"
  | "REVIEW_ADJUST_RECEIVER_ACCELERATE"
  | "SETTLE_PREP"
  | "SETTLE_CLOSE"
  | "CLOSE_PURGE"
  | "REQUEST_PTR"
  | "MEMO_PURGE_PARTIAL_TRANSFER_REQUEST_RECEIVER"
  | "REJECT";

export const AcatsDtccTransferStatusDescriptions: Record<
  AcatsDtccTransferStatus,
  string
> = {
  REQUEST: "100 - Request",
  REQUEST_ADJUST: "110 - Request Adjust",
  REQUEST_ADJUST_PAST: "120 - Request Adjust Past",
  REQUEST_PAST: "130 - Request Past",
  REQUEST_REJECT: "140 - Request Reject",
  REVIEW: "200 - Review",
  REVIEW_ADJUST_DELIVERER: "210 - Review Adjust Deliverer",
  REVIEW_ERROR: "220 - Review Error",
  REVIEW_ACCELERATE: "230 - Review Accelerate",
  REVIEW_ADJUST_RECEIVER_ACCELERATE: "240 - Review Adjust Receiver Accelerate",
  SETTLE_PREP: "300 - Settle Prep",
  SETTLE_CLOSE: "310 - Settle Close",
  CLOSE_PURGE: "400 - Close Purge",
  REQUEST_PTR: "500 - Request (PTR)",
  MEMO_PURGE_PARTIAL_TRANSFER_REQUEST_RECEIVER:
    "510 - Memo Purge Partial Transfer Request Receiver",
  REJECT: "600 - Reject",
};

export type AcatsTransferDirection = "INCOMING" | "OUTGOING";
export type AcatsTransferStatus =
  | "PENDING"
  | "IN_PROGRESS"
  | "REJECTED"
  | "SETTLED";

export type AcatsRejectionReason =
  | "SS_TAX_ID_MISMATCH"
  | "ACCOUNT_TITLE_MISMATCH"
  | "DOCUMENTATION_NEEDED"
  | "ACCOUNT_FLAT"
  | "INVALID_ACCOUNT_NUMBER"
  | "DUPLICATE"
  | "ACCOUNT_IN_DISTRIBUTION_OR_TRANSFER"
  | "CLIENT_RESCINDED"
  | "MISSING_AUTHORIZATION_SIGNATURE"
  | "ACCOUNT_VIOLATES_CREDIT_POLICY_OF_RECEIVING_FIRM"
  | "UNRECOGNIZED_FOR_RESIDUAL_CREDIT_BALANCE"
  | "PARTIAL_TRANSFER_DELIVERER_INITIATED_REJECT"
  | "FAIL_REVERSAL_REJECT"
  | "RECLAIM_REJECT"
  | "MUTUAL_FUND_CLEANUP"
  | "SYSTEM_REJECTED";

export interface AcatsStatusDetails {
  transfer_status?: AcatsTransferStatus;
  dtcc_status?: AcatsDtccTransferStatus;
}

export interface AcatsRejectionDetails {
  rejection_message: string;
  rejection_reason: AcatsRejectionReason;
}

export interface AcatsTransfer {
  acats_id: string;
  account_id: string;
  account_name?: string;
  account_number: string;
  account_type?: string;
  created_at: string;
  contra_account_number: string;
  contra_broker_number: string;
  transfer_type: AcatsDtccTransferType;
  settlement_date?: string;
  transfer_identifier?: string;
  original_transfer_identifier?: string;
  direction: AcatsTransferDirection;
  status: AcatsStatusDetails;
  rejection_details?: AcatsRejectionDetails;
  ip_address?: string;
}

export type AcatsSortDirection = "ASC" | "DESC";
